import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "../../api/axios";
import "../../styles/theme-dark.css";

/* ================================
   ESTILO GLASS
================================ */
function glass(extra = {}) {
  return {
    background: "rgba(15,23,42,0.75)",
    borderRadius: 14,
    border: "1px solid rgba(148,163,184,0.45)",
    backdropFilter: "blur(12px)",
    boxShadow: "0 10px 25px rgba(0,0,0,0.45)",
    ...extra,
  };
}

/* ================================
   PÁGINA SAT (BACKEND REAL)
================================ */
export default function SatPage() {
  const { instalacionId } = useParams();

  const [instalacion, setInstalacion] = useState(null);
  const [incidencias, setIncidencias] = useState([]);
  const [loading, setLoading] = useState(true);

  // Nueva incidencia
  const [mostrarNueva, setMostrarNueva] = useState(false);
  const [titulo, setTitulo] = useState("");
  const [observaciones, setObservaciones] = useState("");

  // Cierre
  const [cerrandoId, setCerrandoId] = useState(null);
  const [textoCierre, setTextoCierre] = useState("");

  useEffect(() => {
    cargarTodo();
  }, [instalacionId]);

  /* ================================
     CARGA INICIAL
  ================================ */
  async function cargarTodo() {
    try {
      setLoading(true);

      const [inst, incs] = await Promise.all([
        axios.get(`/instalaciones/${instalacionId}`),
        axios.get(`/sat/instalacion/${instalacionId}`),
      ]);

      setInstalacion(inst.data);
      setIncidencias(incs.data || []);
    } catch (err) {
      console.error("❌ Error cargando SAT:", err);
    } finally {
      setLoading(false);
    }
  }

  /* ================================
     ACCIONES BACKEND
  ================================ */
  async function crearIncidencia() {
    if (!titulo.trim()) return;

    await axios.post(
      `/sat/instalacion/${instalacionId}/incidencias`,
      { titulo, observaciones }
    );

    setTitulo("");
    setObservaciones("");
    setMostrarNueva(false);
    cargarTodo();
  }

  async function agregarIntervencion(incidenciaId, texto) {
    if (!texto.trim()) return;

    await axios.post(
      `/sat/incidencias/${incidenciaId}/intervenciones`,
      { texto }
    );

    cargarTodo();
  }

  async function cerrarIncidencia(incidenciaId) {
    if (!textoCierre.trim()) return;

    await axios.post(
      `/sat/incidencias/${incidenciaId}/cerrar`,
      { texto: textoCierre }
    );

    setTextoCierre("");
    setCerrandoId(null);
    cargarTodo();
  }

  async function reabrirIncidencia(incidenciaId) {
    await axios.post(
      `/sat/incidencias/${incidenciaId}/reabrir`
    );
    cargarTodo();
  }

  /* ================================
     RENDER
  ================================ */
  if (loading) {
    return (
      <div className="page-dark" style={{ padding: 20 }}>
        Cargando SAT…
      </div>
    );
  }

  if (!instalacion) {
    return (
      <div className="page-dark" style={{ padding: 20 }}>
        Instalación no encontrada
      </div>
    );
  }

  return (
    <div
      className="page-dark"
      style={{
        padding: 16,
        height: "calc(100vh - 70px)",
        display: "flex",
        flexDirection: "column",
        gap: 14,
      }}
    >
      {/* =======================
          CABECERA
      ======================= */}
      <header
        style={glass({
          padding: "14px 18px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        })}
      >
        <div>
          <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>
            SAT · Servicio Técnico
          </h1>
          <div style={{ fontSize: 13, opacity: 0.8, marginTop: 4 }}>
            Cliente: <strong>{instalacion.clienteNombre}</strong> · Instalación{" "}
            <strong>{instalacion.id}</strong>
          </div>
        </div>

        <Link to="/tecnicos" className="glass-btn" style={{ fontSize: 13 }}>
          ← Volver a Técnicos
        </Link>
      </header>

      {/* =======================
          ACCIONES
      ======================= */}
      <div
        style={glass({
          padding: 12,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        })}
      >
        <div style={{ fontSize: 14, fontWeight: 600 }}>
          Incidencias SAT
        </div>

        <button
          className="glass-btn"
          onClick={() => setMostrarNueva(!mostrarNueva)}
        >
          ➕ Agregar incidencia
        </button>
      </div>

      {/* =======================
          NUEVA INCIDENCIA
      ======================= */}
      {mostrarNueva && (
        <div style={glass({ padding: 14 })}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>
            Nueva incidencia
          </div>

          <input
            type="text"
            placeholder="Título del problema"
            value={titulo}
            onChange={(e) => setTitulo(e.target.value)}
            style={{
              width: "100%",
              padding: 10,
              borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.2)",
              background: "rgba(0,0,0,0.3)",
              color: "white",
              marginBottom: 8,
            }}
          />

          <textarea
            placeholder="Observaciones"
            value={observaciones}
            onChange={(e) => setObservaciones(e.target.value)}
            rows={3}
            style={{
              width: "100%",
              padding: 10,
              borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.2)",
              background: "rgba(0,0,0,0.3)",
              color: "white",
              marginBottom: 10,
              resize: "vertical",
            }}
          />

          <div style={{ display: "flex", gap: 8 }}>
            <button className="glass-btn" onClick={crearIncidencia}>
              Guardar incidencia
            </button>
            <button
              className="glass-btn"
              onClick={() => setMostrarNueva(false)}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* =======================
          LISTADO INCIDENCIAS
      ======================= */}
      <div
        style={glass({
          padding: 14,
          flex: 1,
          overflowY: "auto",
        })}
      >
        {incidencias.length === 0 ? (
          <p style={{ opacity: 0.7, fontSize: 13 }}>
            Aún no hay incidencias registradas para esta instalación.
          </p>
        ) : (
          incidencias.map((inc) => (
            <Incidencia
              key={inc.id}
              inc={inc}
              onAdd={agregarIntervencion}
              onClose={cerrarIncidencia}
              onReopen={reabrirIncidencia}
              cerrandoId={cerrandoId}
              setCerrandoId={setCerrandoId}
              textoCierre={textoCierre}
              setTextoCierre={setTextoCierre}
            />
          ))
        )}
      </div>
    </div>
  );
}

/* ================================
   COMPONENTE INCIDENCIA
================================ */
function Incidencia({
  inc,
  onAdd,
  onClose,
  onReopen,
  cerrandoId,
  setCerrandoId,
  textoCierre,
  setTextoCierre,
}) {
  const [texto, setTexto] = useState("");

  return (
    <div style={glass({ padding: 12, marginBottom: 10 })}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 700 }}>{inc.titulo}</div>
          <div style={{ fontSize: 13, opacity: 0.8, marginTop: 4 }}>
            {inc.observaciones}
          </div>
        </div>
        <div style={{ fontSize: 12, opacity: 0.7 }}>{inc.estado}</div>
      </div>

      {/* INTERVENCIONES */}
      {inc.intervenciones?.length > 0 && (
        <div style={{ marginTop: 10 }}>
          {inc.intervenciones.map((itv) => (
            <div
              key={itv.id}
              style={{
                fontSize: 12,
                padding: "6px 8px",
                marginBottom: 6,
                borderLeft: itv.esCierre
                  ? "3px solid #22c55e"
                  : "3px solid #3b82f6",
                background: "rgba(255,255,255,0.05)",
                borderRadius: 6,
              }}
            >
              {itv.texto}
              <div style={{ opacity: 0.6, marginTop: 2 }}>
                {new Date(itv.createdAt).toLocaleString()}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ACCIONES */}
      <div style={{ marginTop: 10 }}>
        {inc.estado === "abierta" ? (
          <>
            <textarea
              placeholder="Agregar intervención / trabajo realizado"
              value={texto}
              onChange={(e) => setTexto(e.target.value)}
              rows={3}
              style={{
                width: "100%",
                padding: 10,
                borderRadius: 8,
                border: "1px solid rgba(255,255,255,0.2)",
                background: "rgba(0,0,0,0.3)",
                color: "white",
                marginBottom: 8,
                resize: "vertical",
              }}
            />

            <div style={{ display: "flex", gap: 8 }}>
              <button
                className="glass-btn"
                onClick={() => {
                  onAdd(inc.id, texto);
                  setTexto("");
                }}
              >
                ➕ Agregar intervención
              </button>

              <button
                className="glass-btn"
                onClick={() => setCerrandoId(inc.id)}
              >
                ✅ Reparada
              </button>
            </div>
          </>
        ) : (
          <button className="glass-btn" onClick={() => onReopen(inc.id)}>
            🔁 Volver a abrir
          </button>
        )}
      </div>

      {/* CIERRE */}
      {cerrandoId === inc.id && (
        <div style={{ marginTop: 10 }}>
          <textarea
            placeholder="¿Cómo se solucionó definitivamente?"
            value={textoCierre}
            onChange={(e) => setTextoCierre(e.target.value)}
            rows={3}
            style={{
              width: "100%",
              padding: 10,
              borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.2)",
              background: "rgba(0,0,0,0.3)",
              color: "white",
              marginBottom: 8,
            }}
          />

          <div style={{ display: "flex", gap: 8 }}>
            <button
              className="glass-btn"
              onClick={() => onClose(inc.id)}
            >
              Solucionado
            </button>
            <button
              className="glass-btn"
              onClick={() => setCerrandoId(null)}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
